import React from 'react';
import { ProductTileProps } from "../../../ProductTile/types";
import BodyText from "../../../../ui/Typography/texts/BodyText";
const AdditionalDetails = ({ additionalDetails }) => {
    if (additionalDetails === null || additionalDetails === void 0 ? void 0 : additionalDetails.length) {
        return (React.createElement(React.Fragment, null, additionalDetails.map((item) => (React.createElement(BodyText, { marginless: true, key: item.text }, item.text)))));
    }
    return null;
};
export default AdditionalDetails;
//# sourceMappingURL=AdditionalDetails.js.map